import { render, staticRenderFns } from "./SwitchProposalOrGuideline-comp.vue?vue&type=template&id=e08b9d78&scoped=true&"
import script from "./SwitchProposalOrGuideline-comp.vue?vue&type=script&lang=js&"
export * from "./SwitchProposalOrGuideline-comp.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProposalOrGuideline-comp.vue?vue&type=style&index=0&id=e08b9d78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08b9d78",
  null
  
)

export default component.exports